import { useCallback, useEffect, useState } from 'react';
import { AuditPage, fetchAuditLogs } from '../../../api/accessApi';
import { formatTime, useAsync } from './shared';

const PAGE_SIZE = 25;

export default function AuditTab() {
  const [page, setPage] = useState<AuditPage | null>(null);
  const [action, setAction] = useState('');
  const [username, setUsername] = useState('');
  const [offset, setOffset] = useState(0);
  const { error, busy, run } = useAsync();

  const load = useCallback(
    () =>
      run(() =>
        fetchAuditLogs({
          action: action || undefined,
          username: username.trim() || undefined,
          limit: PAGE_SIZE,
          offset,
        }),
      ).then((p) => p && setPage(p)),
    [run, action, username, offset],
  );
  useEffect(() => {
    load();
  }, [load]);

  const total = page?.total ?? 0;

  return (
    <section className="panel">
      <h2>Audit log</h2>
      {error && <p className="acc-error">{error}</p>}
      <div className="acc-form acc-inline">
        <label>
          Action
          <select
            value={action}
            onChange={(e) => {
              setOffset(0);
              setAction(e.target.value);
            }}
          >
            <option value="">All actions</option>
            {page?.actions.map((a) => (
              <option key={a} value={a}>
                {a}
              </option>
            ))}
          </select>
        </label>
        <label>
          Username
          <input
            value={username}
            placeholder="Filter by username"
            onChange={(e) => {
              setOffset(0);
              setUsername(e.target.value);
            }}
          />
        </label>
        <button className="btn" disabled={busy} onClick={load}>
          Refresh
        </button>
      </div>
      <div className="acc-scroll">
        <table className="acc-table">
          <thead>
            <tr>
              <th>When</th>
              <th>User</th>
              <th>Action</th>
              <th>Details</th>
              <th>IP</th>
            </tr>
          </thead>
          <tbody>
            {page?.items.map((r) => (
              <tr key={r.id}>
                <td>{formatTime(r.created_at)}</td>
                <td>{r.username || '–'}</td>
                <td>
                  <span className="tag">{r.action}</span>
                </td>
                <td className="acc-detail">{r.detail ? JSON.stringify(r.detail) : ''}</td>
                <td>{r.ip_address ?? ''}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {page && page.items.length === 0 && <p className="note">No matching events.</p>}
      </div>
      <div className="acc-bar acc-pager">
        <span>
          {total === 0 ? 0 : offset + 1}–{Math.min(offset + PAGE_SIZE, total)} of {total}
        </span>
        <span>
          <button className="btn" disabled={offset === 0 || busy} onClick={() => setOffset(Math.max(0, offset - PAGE_SIZE))}>
            Previous
          </button>{' '}
          <button className="btn" disabled={offset + PAGE_SIZE >= total || busy} onClick={() => setOffset(offset + PAGE_SIZE)}>
            Next
          </button>
        </span>
      </div>
    </section>
  );
}
